import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { OwlOptionsSliderConfig } from 'src/app/utils/Carousel-config';
import { getImgeUrl } from 'src/environments/environment';

@Component({
  selector: 'app-home-book',
  standalone: true,
	imports: [CarouselModule, RouterLink, CommonModule],
  templateUrl: './home-book.component.html',
  styleUrl: './home-book.component.scss'
})
export class HomeBookComponent {
	isToggled = false;
	books
	imageUrl = getImgeUrl()
    categoriesSlides: OwlOptions = OwlOptionsSliderConfig

	constructor(
	  public themeService: ThemeCustomizerService,
	  private publicService: PublicServiceService
	) {
	  this.themeService.isToggled$.subscribe(isToggled => {
		this.isToggled = isToggled;
	  });
	}
  
	toggleTheme() {
	  this.themeService.toggleTheme();
	}
  
	ngOnInit(): void { 
	  this.getData()
	}
  
	getData() {
		this.publicService.getRecordHome(this.publicService.BOOKS_URL).subscribe({
		  next: (res) => {
			this.books = res
	
		  },
		  error: (error) => {
			console.error("here goes the Unexpected error:", error);
		  }
		})
	  }


}
